import {React , useEffect} from "react";
import { motion } from "framer-motion";
import image from '../assets/contact.jpg';
import { useTheme } from './ThemeContext';
import AOS  from 'aos';
const Contact = () => {
    const { isDarkMode } = useTheme();
    useEffect(() =>
    {
        AOS.init({
            duration: 1000
        });
    })
    return (
        <section id="contact" className={`lg:px-28 md:px-20 px-10 py-8 mt-16 ${isDarkMode ? 'dark' : ''}`}>
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.5 }}
                variants={{
                    hidden: { opacity: 0, x: 50 },
                    visible: { opacity: 1, x: 0 },
                }}
                className="flex justify-center "
            >
                <div>
                    <p data-aos="fade-up" className="text-white mx-auto px-2 text-center text-2xl dark:shadow-yellow-300 dark:shadow-lg font-extrabold bg-[#235191] rounded-full items-center mt-20 lg:py-4 py-2 md:py-3 lg:px-5">
                        <span className="text-yellow">CONTACT US</span> TO GET STARTED
                    </p>
                </div>
            </motion.div>

            <div data-aos="zoom-in-up" className="md:flex md:justify-between gap-16 mt-8">
                <div className="mx-auto mt-6">
                    <img src={image} className="rounded-2xl border-2 h-96 w-full mb-10 border-[#235191] dark:border-[#3FE0A5]" alt="contact" />
                </div>
                <div className="flex flex-col justify-center ">
                    <p className="text-gray-800 text-lg md:text-xl mb-5 dark:text-zinc-300">Have any questions or need assistance?</p>
                    <p className="text-gray-700 mb-5 dark:text-zinc-400">Feel free to reach out to us on Whatsapp:</p>
                    <a href="https://wa.me/923493476657" className="px-8 py-4 bg-[#3FE0A5] text-gray-900 rounded-lg hover:bg-[#235191] hover:text-white duration-500 inline-block font-semibold">
                        Send a Message
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Contact;
